var map = {
	"./Gallery-1.jpg": 37,
	"./Gallery-10.jpg": 38,
	"./Gallery-11.jpg": 39,
	"./Gallery-12.jpg": 40,
	"./Gallery-13.jpg": 41,
	"./Gallery-15.jpg": 42,
	"./Gallery-16.jpg": 43,
	"./Gallery-17.jpg": 44,
	"./Gallery-18.jpg": 45,
	"./Gallery-19.jpg": 46,
	"./Gallery-2.jpg": 47,
	"./Gallery-20.jpg": 48,
	"./Gallery-21.jpg": 49,
	"./Gallery-22.jpg": 50,
	"./Gallery-23.jpg": 51,
	"./Gallery-3.jpg": 52,
	"./Gallery-4.jpg": 53,
	"./Gallery-5.jpg": 54,
	"./Gallery-6.jpg": 55,
	"./Gallery-7.jpg": 56,
	"./Gallery-8.jpg": 57,
	"./Gallery-9.jpg": 58,
	"./Gallery-BG.jpg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;